import React from "react";
import { NumberInput, required } from "react-admin";

export const AuthSetting: React.FC = (props) => {
  return (
    <>
      <NumberInput
        label="客户登录过期时间(分钟)"
        source="setting.userTimeOutMinutes"
        validate={required()}
        step={1}
      />
      <NumberInput
        label="客户不操作过期时间(分钟)"
        source="setting.userTimeOutDelayMinutes"
        validate={required()}
        step={1}
      />
    </>
  );
};
